import React, {
  useState,
  useRef,
  memo,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from 'react';
import { Checkbox } from 'antd';

const AgCheckboxEditor = memo(
  forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value);
    const refCheckbox = useRef(null);
    const disabled = props.disabled;

    useEffect(() => {
      refCheckbox.current.focus();
    }, []);

    useImperativeHandle(ref, () => ({
      getValue() {
        return value;
      },
    }));

    return (
      <Checkbox
        ref={refCheckbox}
        checked={value}
        disabled={disabled}
        onChange={(event) => {
          setValue(event.target.checked);
          props.afterChange &&
            props.afterChange(props.data.moduleId || props.data.id, {
              [props?.colDef?.field?.[0]]: event.target.checked,
            });
        }}
      />
    );
  }),
);

export default AgCheckboxEditor;
